import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const PlanMiniSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện khác'}  
            childCate={'Quạt mini'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default PlanMiniSub
